/** True when the browser sends the Global Privacy Control signal (false during server render). */
export function isGpcEnabled() {
    if (typeof navigator === 'undefined')
        return false;
    return navigator.globalPrivacyControl === true;
}
//# sourceMappingURL=gpc.js.map